export default "__VITE_ASSET__DffiUUVH__"